<template>
	<div>
		<h3 v-if="heading" class="title is-6 column-title" v-text="heading" />
		<div :class="{ box: boxed }">
			<div v-if="data" class="content">
				<span v-html="content" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		content() {
			return this.data.content;
		},
		heading() {
			return this.data.title;
		},
		boxed() {
			return this.data.boxed;
		}
	}
};
</script>

<style scoped>
.content {
	font-size: 0.9em;
}
</style>
